"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background: ", ";\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  ", "\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n\n  &:last-child {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    &:hover {\n      box-shadow: none;\n    }\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:disabled,\n  &[disabled] {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemHighlighted = exports.menuItemSelected = exports.menuItemBase = void 0;

var _core = require("@emotion/core");

var _utilities = require("../../utilities");

var menuItemBase = function menuItemBase(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), _utilities.utilities.typography.paragraph(theme), theme.bColorneutral01, _utilities.utilities.border.thin({
    theme: theme,
    color: 'transparent'
  }), _utilities.utilities.surface.hover({
    theme: theme
  }), _utilities.utilities.surface.selected({
    theme: theme
  }), _utilities.utilities.surface.disabled({
    theme: theme
  }));
};

exports.menuItemBase = menuItemBase;

var menuItemSelected = function menuItemSelected(_ref2) {
  var theme = _ref2.theme,
      selected = _ref2.selected;
  return selected && (0, _core.css)(_templateObject2(), theme.bColorsecondary01);
};

exports.menuItemSelected = menuItemSelected;

var menuItemHighlighted = function menuItemHighlighted(_ref3) {
  var theme = _ref3.theme,
      highlighted = _ref3.highlighted;
  return highlighted && (0, _core.css)(_templateObject3(), theme.bColorsecondary01);
};

exports.menuItemHighlighted = menuItemHighlighted;